import { PROVIDER_LABELS, PROVIDERS } from '@asko/shared';
import { useI18n } from '../lib/i18n';

/**
 * Scoring kutish ekrani (BT §7.2, 3-ekran; §7.4).
 *
 * Sotuvchi ikkala so'rov bir vaqtda ketayotganini ko'rib turishi kerak —
 * shuning uchun provayderlar ro'yxati alohida ko'rsatiladi.
 */
export function ScoringLoader() {
  const { t } = useI18n();

  return (
    <div className="card scoring-wait">
      <div className="spinner" aria-hidden="true" />
      <h2 className="scoring-wait__title">{t('scoring.waitTitle')}</h2>
      <p className="scoring-wait__hint">{t('scoring.waitHint')}</p>

      <ul className="scoring-wait__list">
        {PROVIDERS.map((provider) => (
          <li key={provider}>
            <span className="scoring-wait__dot" aria-hidden="true" />
            {PROVIDER_LABELS[provider]}
          </li>
        ))}
      </ul>
    </div>
  );
}
